// extracted by mini-css-extract-plugin
export default {"shimmer":"TopUpModals_shimmer__kuO79","dark_shimmer":"TopUpModals_dark_shimmer__XwyJV","topupModal":"TopUpModals_topupModal__W32uO","listtop":"TopUpModals_listtop__7UdFU"};